import * as React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: props.colorr,
          //   width: "62px",
          //   height: "62px",
        }}
        {...props}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          sx={{
            fontWeight: "bold",
            fontSize: "20px",
          }}
        >
          {
            <>
              {props?.value !== null && !isNaN(props?.value)
                ? `${`${props?.value}`?.substring(
                    0,
                    `${props?.value}`?.split(".")?.[0]?.length
                  )}`
                : "0"}

              {`${props?.value}`?.split(".")[1]?.substring(0, 2) ? (
                <>.{`${props?.value}`?.split(".")[1]?.substring(0, 2)}</>
              ) : null}
            </>
          }
        </Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

export default function CircularStatic(props) {
  return <CircularProgressWithLabel value={props.value} colorr={props.color} />;
}
